import { FormCheckbox } from '@ariakit/react';
import styled, { css } from 'styled-components';
import { timingDefault } from '../../constants';
const hideVisually = css `
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const HiddenInput = styled.input `
  ${hideVisually}
`;
export const Label = styled.label `
  cursor: ${o => (o.$disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  padding: 6px 0;

  > input {
    ${hideVisually}
  }

  /* 'data-focus-visible' is added by AriaKit.Focusable */
  &:has(input[data-focus-visible]) {
    outline: 1px auto Highlight;
    outline: 1px auto -webkit-focus-ring-color;
  }

  &:hover {
    outline: none;
  }
`;
export const AriaKitCheckbox = styled(FormCheckbox) `
  border: 1px solid ${o => o.theme.color.input.empty.border.on.background};
  border-radius: 2px;
  box-sizing: border-box;
  height: 16px;
  width: 16px;
  accent-color: ${o => o.theme.color.input.filled.content.on.background};
  cursor: pointer;
`;
export const Checkbox = styled.div `
  background: ${o => o.$disabled ? o.theme.color.deprecated.stoneDark : o.$checked ? 'black' : 'white'};
  border: 1px solid
    ${o => (o.$disabled ? o.theme.color.deprecated.stoneDark : o.theme.color.deprecated.obsidian)};
  border-radius: 2px;
  box-sizing: border-box;
  display: inline-block;
  flex: 0 0 auto;
  height: 16px;
  margin-inline-end: 12px;
  opacity: ${o => !o.$checked && '0.6'};
  position: relative;
  top: 2px;
  width: 16px;

  > svg {
    left: 50%;
    opacity: ${o => !o.$checked && '0'};
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity ${timingDefault};
  }

  ${Label}:hover & {
    &:before {
      content: '';
      display: ${o => (o.$hover ? 'inline' : 'none')};
      position: absolute;
      width: 2px;
      height: 9px;
      background-color: ${o => o.theme.color.deprecated.stone};
      left: 7px;
      top: 3px;
      transform: rotate(45deg);
    }

    &:after {
      content: '';
      display: ${o => (o.$hover ? 'inline' : 'none')};
      position: absolute;
      width: 3px;
      height: 2px;
      background-color: ${o => o.theme.color.deprecated.stone};
      left: 2px;
      top: 7px;
      transform: rotate(45deg);
    }
  }
`;
//# sourceMappingURL=styles.js.map